import React from 'react';

function SkeletonWrapper({ children, renderTimes }) {
  return (
    <>
      {Array(renderTimes)
        .fill('')
        .map(() => children)}
    </>
  );
}

export default SkeletonWrapper;
